// extracted by mini-css-extract-plugin
module.exports = {"toggleBtn":"OptInSwitch_toggleBtn__ygHLH","toggleBtnSuccess":"OptInSwitch_toggleBtnSuccess__T8ly8"};